export enum Controles {

  FACTORAJE_MENU = 138,
  FACTORAJE_NUEVA_SOLICITUD = 139,
  FACTORAJE_HISTORIAL_SOLICITUDES = 140,
  FACTORAJE_AUTORIZAR_SOLICITUD = 153,

  FIDEICOMISOS_MENU = 137,
  FIDEICOMISOS_MOVIMIENTOS_INVERSION = 152,
  FIDEICOMISOS_ALTA_MOVIMIENTOS_INVERSION = 164,
  FIDEICOMISOS_AGREGAR_MOVIMIENTOS_RENDIMIENTOS = 155,
  FIDEICOMISOS_GASTOS = 163,

  ELIMINAR_DOCUMENTOS_FIGURAS_ADHERENTES = 141,
  ELIMINAR_DOCUMENTOS_LOTES = 142,
  ELIMINAR_DOCUMENTOS_FIGURAS = 143,
  ELIMINAR_FIGURAS = 144,
  PAGO_DEPOSITO_INVERSION = 151,
  ELIMINAR_DOCUMENTOS_RENDIMIENTOS = 157,
  EDITAR_MOVIMIENTO_INVERSION = 158,
  ELIMINAR_DOCUMENTOS_INVERSION = 165,
  EDITAR_MOVIMIENTO_EGRESO = 166

}
